import {CheckRow} from "./check-row";
import {CheckTableIterator} from "./check-table-iterator";

/*
 [CheckTable]: Encapsulates operations upon a table with rows that have checkbox cells.  When the rows background color
 changes to reflect if the row is checked or not.

 Methods
 getCount(): Get the number of valid rows.
 getRow(rowID): Get a row given its unique id.
 iterator(): get a CheckTableIterator for the table.
 getCheckedIDs(separator): get the set of rows that are currently checked, delimited by a separator string.
 getUncheckedIDs(separator)
 setCheckedIDs(idArray)
 setUncheckedIDs(idArray)
 getCheckedCount(): get the number of rows that are currently checked.
 */
export function CheckTable(
    tableElm, // the element object of the table that has rows with checkbox inputs (document.getElementById("listTable") for example).
    rowDefClassName, // CSS class name for when the row is not highlighted
    rowHighliteClassName,
    rowPrefix, // Each row element must have an elment id.  The element id is a concatenation of a prefix and a unique identifier.
    rowCheckPrefix
) {
    // The table must have checbox input elements to select and unselect the rows.  These elements must have an id.
    // The element id is a concatenation of a prefix and a unique identifier.  The unique identifier must match that of its containing row.
    // > fields <//
    this.tableElm = tableElm;
    this.rowDefClassName = rowDefClassName;
    this.rowHighliteClassName = rowHighliteClassName;
    this.rowPrefix = rowPrefix;
    this.rowCheckPrefix = rowCheckPrefix;

    // > methods <//
    this.getCount = function() {
        let itr = this.iterator();
        let row;
        let count = 0;
        let i = 0;
        while (itr.hasNext()) {
            row = itr.next();
            if (row) count++;
        }

        return count;
    };

    this.getRow = function(rowID) {
        let rowElm = document.getElementById(this.rowPrefix + rowID);
        let chkElm = document.getElementById(this.rowCheckPrefix + rowID);
        if (rowElm && chkElm)
            return new CheckRow(
                rowID,
                rowElm,
                chkElm,
                this.rowDefClassName,
                this.rowHighliteClassName
            );
        else return null;
    };

    /* Gets the TR row by the given index.  */
    this.getRowByIndex = function(rowIndex) {
        let rowElm = this.tableElm.rows[rowIndex];
        let chkElm = rowElm && rowElm.querySelector("input[type=checkbox]");
        if (rowElm && chkElm)
            return new CheckRow(
                rowElm.id.replace(this.rowPrefix, ""),
                rowElm,
                chkElm,
                this.rowDefClassName,
                this.rowHighliteClassName
            );
        else return null;
    };

    this.iterator = function() {
        return new CheckTableIterator(this);
    };

    this.getCheckedIDs = function(separator) {
        return this._getCheckedHelper(true, separator);
    };

    this.getUncheckedIDs = function(separator) {
        return this._getCheckedHelper(false, separator);
    };

    this._getCheckedHelper = function(wantChecked, separator) {
        if (!separator) separator = ",";

        let itr = this.iterator();
        let row;
        let result = "";
        let first = true;
        let rowChecked;
        while (itr.hasNext()) {
            row = itr.next();
            if (row) {
                rowChecked = row.getChecked();
                if ((wantChecked && rowChecked) || (!wantChecked && !rowChecked)) {
                    if (!first) result = result + separator;
                    else first = false;

                    result = result + row.id;
                }
            }
        }

        return result;
    };

    this.setCheckedIDs = function(elms) {
        this._setCheckedHelper(true, elms);
    };

    this.setUncheckedIDs = function(elms) {
        this._setCheckedHelper(false, elms);
    };

    this._setCheckedHelper = function(wantChecked, elms) {
        if (!elms) {
            console.error("elms is undefined in CheckTable...");
            return;
        }

        let elmLen = elms.length;
        let i = 0;

        let itr = this.iterator();
        let row;
        let found;
        while (itr.hasNext()) {
            row = itr.next();
            if (row) {
                i = 0;
                found = false;
                while (i < elmLen) {
                    if (elms[i] == row.id) {
                        row.setChecked(wantChecked);
                        found = true;
                        break;
                    }
                    i++;
                }

                if (!found) row.setChecked(!wantChecked);
            }
        }
    };

    this.getCheckedCount = function() {
        let itr = this.iterator();
        let row;
        let count = 0;
        while (itr.hasNext()) {
            row = itr.next();
            if (row && row.getChecked()) count++;
        }

        return count;
    };

    this.checkAll = function(checked) {
        // iterate over each row and set the check state
        let itr = this.iterator();
        let row;
        while (itr.hasNext()) {
            row = itr.next();
            if (row) row.setChecked(checked);
        }
    };

}